import { render, staticRenderFns } from "./BarShutterDescription.vue?vue&type=template&id=b7e7a14a&scoped=true"
import script from "./BarShutterDescription.vue?vue&type=script&lang=ts"
export * from "./BarShutterDescription.vue?vue&type=script&lang=ts"
import style0 from "./BarShutterDescription.vue?vue&type=style&index=0&id=b7e7a14a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e7a14a",
  null
  
)

export default component.exports